/*global define*/

define("models/Tool", [
    'underscore',
    'backbone',
    'chemistry/BunsenBurner',
    'chemistry/Cooling'
], function (_, Backbone, BunsenBurner, Cooling) {
    'use strict';

    var ToolModel = Backbone.Model.extend({
        defaults: {
            weight: 0,
            bunsenBurner: null
        },
        events: {
            "destroy": "destroyCalled"
        },
        initialize: function(toolData){
            this.set("tool", toolData);
            if (toolData.name === "Bunsen_Burner") {
                this.set("bunsenBurner", new BunsenBurner());
            }
        },
        destroyCalled: function(){
        },
        bunsen: function(vessel, attach){
            if (attach) {
                var solution = vessel.get("solution");
                if (solution !== null) {
                    solution.setThermal(this.get("bunsenBurner"));
                }
            }
            else {
                var solution= vessel.get("solution");
                if (solution !== null) {
                    if (!solution.insulated)
                        solution.setThermal(new Cooling());
                    else
                        solution.setThermal(null);
                }
            }
        },
        scale: function(vessel, attach){
            var weight = this.get("weight");
            if (attach) {
                this.set("weight", weight + vessel.getWeight());
            }
            else {
                this.set("weight", weight - vessel.getWeight());
            }
        }
    });

    return ToolModel;
});
